import axios from 'axios';

import buildPaginationQueryOpts from '@/shared/sort/sorts';

import { ISubmissionJudgement } from '@/shared/model/submission-judgement.model';
import buildCriteriaQuery from '@/shared/criteria/criterias';

const baseApiUrl = 'api/submission-judgements';

export default class SubmissionJudgementService {
  public find(id: number): Promise<ISubmissionJudgement> {
    return new Promise<ISubmissionJudgement>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/${id}`)
        .then(function(res) {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public retrieveByCriteria(paginationQuery?: any, criteriaQuery?: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(baseApiUrl + `?${buildPaginationQueryOpts(paginationQuery)}${buildCriteriaQuery(criteriaQuery)}`)
        .then(function(res) {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public retrieve(paginationQuery?: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(baseApiUrl + `?${buildPaginationQueryOpts(paginationQuery)}`)
        .then(function(res) {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public delete(id: number): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .delete(`${baseApiUrl}/${id}`)
        .then(function(res) {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public create(entity: ISubmissionJudgement): Promise<ISubmissionJudgement> {
    return new Promise<ISubmissionJudgement>((resolve, reject) => {
      axios
        .post(`${baseApiUrl}`, entity)
        .then(function(res) {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public update(entity: ISubmissionJudgement): Promise<ISubmissionJudgement> {
    return new Promise<ISubmissionJudgement>((resolve, reject) => {
      axios
        .put(`${baseApiUrl}`, entity)
        .then(function(res) {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
}
